export default {
    TAMANHO_PAGINA: 20,
    CLIENT_ID_ALVORADA: 'client-alvorada-sustentavel'
};
